import { render } from "./Index.vue?vue&type=template&id=440a2be2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=440a2be2&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=440a2be2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-440a2be2"

export default script